<template>
  <div
    class="full-height-section container-fluid px-0"
    :style="{ backgroundColor: '#233d72', color: 'white' }"
  >
    <h1 class="page-title">Seguros para Personas</h1>

    <div class="service-grid row gx-0">
      <div
        v-for="(servicio, index) in servicios"
        :key="index"
        class="col-md-4 p-0"
      >
        <div
          class="service-card"
          :style="{
            backgroundImage: `url('${servicio.imagen}')`,
            animationDelay: (0.2 + index * 0.2) + 's'
          }"
          @click="abrirOverlay(servicio)"
        >
          <div class="overlay"></div>
          <div class="service-content">{{ servicio.titulo }}</div>
        </div>
      </div>
    </div>

    <!-- Tarjeta flotante tipo overlay -->
    <div v-if="overlayVisible" class="custom-overlay">
      <div class="overlay-card">
        <button class="close-btn" @click="cerrarOverlay">×</button>
        <h2 class="overlay-title">{{ overlayData.titulo }}</h2>
        <p class="overlay-description">{{ overlayData.descripcion }}</p>

        <div class="overlay-image-container">
          <img
            :src="overlayData.imagen"
            alt="Imagen del seguro"
          />
        </div>

        <div class="overlay-btn-container">
          <button
            class="btn btn-warning custom-btn"
            @click="irAFormulario"
          >
            Contratar Seguro
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiciosPersonales",
  data() {
    return {
      overlayVisible: false,
      overlayData: {},
      servicios: [
        {
          titulo: "SEGURO DE GASTOS MÉDICOS MAYORES",
          imagen: "https://img.freepik.com/foto-gratis/banner-medico-medico-guante_23-2149611205.jpg?t=st=1753298315~exp=1753301915~hmac=8e86b574636a232c8bb657c8213b8e4e3d9912051778d7cf7ef91202c13e7da6&w=1380",
          imagenModal: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=800&q=80",
          descripcion: "Te respalda ante imprevistos de salud, cubriendo hospitalización, tratamientos, cirugías y emergencias. Es una herramienta poderosa para cuidar tu bienestar sin comprometer tus finanzas. Ideal si buscas tranquilidad médica con atención de calidad en todo momento.",
          customClass: "custom-card-size",
        },
        {
          titulo: "SEGURO DE VIDA",
          imagen: "https://img.freepik.com/foto-gratis/manos-que-sostienen-apoyarse_23-2150446026.jpg?t=st=1753298392~exp=1753301992~hmac=458de39449b6a67901c31e7b0ac2b0f0825e8e12004193bf63f886523b917fa5&w=1380",
          imagenModal: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=800&q=80",
          descripcion: "Brinda respaldo económico a las personas que más quieres en caso de que llegues a faltar. Es una forma de cuidar su estabilidad y proteger sus sueños. Lo necesitas si deseas dejar un legado de seguridad y amor.",
          customClass: "tarjeta-card-size",
        },
        {
          titulo: "SEGURO EDUCATIVO",
          imagen: "https://img.freepik.com/foto-gratis/cerrar-manos-sosteniendo-diplomas-gorras_23-2148950575.jpg?t=st=1753298477~exp=1753302077~hmac=2487ed5ca2869ec907d651fd5c7a7d89fb04d391ea7ed48750d4e1790c0c0c18&w=1380",
          imagenModal: "https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?auto=format&fit=crop&w=800&q=80",
          descripcion: "Asegura que tus hijos o seres queridos tengan acceso a una educación universitaria sin preocupaciones financieras. Es una inversión para su futuro. Perfecto si deseas garantizar que sigan estudiando, pase lo que pase.",
          customClass: "custom-card-size",
        },
        {
          titulo: "SEGURO DE AHORRO",
          imagen: "https://img.freepik.com/foto-gratis/plantar-arboles-pila-monedas-luz-sol_1150-17741.jpg?t=st=1753298536~exp=1753302136~hmac=9b48b51665222978f21c2d8fb915e255139eab52beb37826bff443ff71580a0b&w=1380",
          imagenModal: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&w=800&q=80",
          descripcion: "Combina protección con disciplina financiera. Te permite ahorrar de forma estructurada para metas como viajes, emprendimientos o tranquilidad a futuro. Lo necesitas si quieres construir un respaldo con propósito y seguridad.",
          customClass: "",
        },
        {
          titulo: "SEGURO DE PENSIÓN",
          imagen: "https://img.freepik.com/free-photo/old-man-woman-looking-phone_23-2148293873.jpg?t=st=1753298598~exp=1753302198~hmac=cb540d1df1beaca7a2fb9efbd21ed93c994c3d0c1228339d3fb10c3c09362b29&w=900",
          
          descripcion: "Diseñado para ayudarte a construir un ingreso sólido y confiable para tu retiro. Te ofrece independencia y libertad financiera en la etapa más tranquila de tu vida. Ideal si quieres vivir con plenitud el mañana desde hoy.",
          customClass: "tarjeta-card-size",
        },
        {
          titulo: "SEGURO PARA LA MUJER",
          imagen: "https://img.freepik.com/free-photo/low-angle-businesswoman-posing-with-arms-crossed-outdoors_23-2148767034.jpg?t=st=1753298699~exp=1753302299~hmac=63842bb0463ad598b90764e8690274395aa9133c2c54d566f7441e60453c136d&w=900",
          descripcion: "Creado especialmente para ti. Te protege ante diagnósticos delicados como cáncer femenino, complicaciones médicas, y te acompaña con beneficios en momentos clave de tu vida. Es una forma inteligente de cuidarte con visión y amor propio.",
          customClass: "",
        },
        {
          titulo: "SEGURO DE VIAJERO",
          imagen: "https://img.freepik.com/foto-gratis/familia-tiro-completo-viajando-juntos_23-2149272092.jpg?t=st=1753298748~exp=1753302348~hmac=483788258615aef95410fd95e384f104bec48c3d15dd68f449de50ccaa8127b1&w=1380",
          descripcion: "Viaja con confianza. Este seguro cubre atenciones médicas, contratiempos, pérdida de equipaje y más durante tus traslados. Es esencial si disfrutas explorar el mundo, viajar por trabajo o quieres seguridad total al salir de casa.",
          customClass: "tarjeta-card-size",
        },
        {
          titulo: "SEGURO DE HOMBRE CLAVE",
          imagen: "https://images.unsplash.com/photo-1578574577315-3fbeb0cecdc2?q=80&w=872&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          descripcion: "Protege la estabilidad de tu empresa en caso de que una persona esencial ya no pueda continuar en funciones, además de tener un beneficio fiscal. Permitiendo la continuidad operativa y financiera de tu empresa.",
          customClass: "",
        },
        {
          titulo: "SEGURO INTER SOCIOS",
          imagen: "https://img.freepik.com/foto-gratis/concepto-hombres-negocios-apreton-manos_53876-31214.jpg?t=st=1753298842~exp=1753302442~hmac=dd226bf3673154b285d1ee866e8b43f20443c15d8f315dac7894f60a12406b98&w=1380",
          descripcion: "Asegura la participación de cada socio en caso de eventos inesperados. Evita conflictos y asegura la permanencia de la empresa. Lo necesitas si deseas proteger la estructura, acuerdos y visión corporativa de tu negocio.",
          customClass: "",
        },
      ],
    };
  },
  methods: {
    abrirOverlay(servicio) {
      this.overlayData = servicio;
      this.overlayVisible = true;
    },
    cerrarOverlay() {
      this.overlayVisible = false;
    },
    irAFormulario() {
      this.$router.push("/formulario_contacto");
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');

.full-height-section {
  min-height: 100vh;
  padding-top: 20px;
}

.page-title {
  text-align: center;
  margin-bottom: 40px;
  font-size: 2.5rem;
  text-transform: uppercase;
}

.service-card {
  position: relative;
  height: 200px;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  opacity: 0;
  animation: fadeInUp 0.8s ease forwards;
}

.service-card:hover {
  transform: translateY(-5px) scale(1.03);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #233d7265;
}

.service-content {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  color: white;
  font-weight: bold;
  font-size: 1.3rem;
  text-align: center;
  z-index: 3;
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
}

@keyframes fadeInUp {
  0% { opacity: 0; transform: translateY(30px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* Overlay flotante */
.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 15px;
}

.overlay-card {
  background: white;
  color: black;
  padding: 20px;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
}

.overlay-title {
  margin-bottom: 15px;
  font-family: 'Open Sans', serif;
  font-weight: normal;
  font-size: 1.2rem; /* tamaño más pequeño */
  line-height: 1.4; /* interlineado cómodo */
}

.overlay-description {
  text-align: left;
  margin-bottom: 20px;
}

.overlay-image-container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.overlay-image-container img {
  max-width: 60%;  /* antes 80%, ahora más pequeña */
  max-height: 250px; /* límite de altura */
  object-fit: contain; /* mantiene proporciones sin recortar */
  border-radius: 8px;
}

.overlay-btn-container {
  display: flex;
  justify-content: center;
}

.custom-btn {
  min-width: 160px;
  padding: 8px 16px;
  font-size: 1rem;
}

</style>